import React, { useEffect, useState } from 'react';
import { getClassMessages, sendMessage } from '../../api/class';
import { toast } from 'react-toastify';
import { projectStorage } from '../../firebase';

const Messages = ({ user, cid }) => {
    const initialvals = {
        title: 'title',
        message: 'message',
        docs: [],
        sent_by: user._id,
        time: ''
    }
    const [values, setValues] = useState(initialvals)
    const [messages, setMessages] = useState([])
    const [loading, setLoading] = useState(true)
    const [disable, setDisable] = useState(false)
    const [docs, setDocs] = useState([])
    const types = ['application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/plain', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/png', 'image/jpeg']

    useEffect(() => {
        loadMessages()
    }, [])

    const loadMessages = () => {
        getClassMessages(cid)
            .then(res => {
                setMessages(res.data)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
            })
    }

    const checkFiles = files => {
        return new Promise((resolve, reject) => {
            const newFiles = []
            for (let i = 0; i < files.length; i++) {
                if (files[i] && types.includes(files[i].type))
                    newFiles.push(files[i])
                else
                    reject([])
            }
            resolve(newFiles)
        })
    }

    const handleDocSelect = async e => {
        if (e.target.files.length > 0 && e.target.files.length <= 3) {
            checkFiles(e.target.files)
                .then(res => {
                    setDisable(true)
                    res.map(eachFile => {
                        let storageRef = ''
                        if (eachFile.type === 'image/png' || eachFile.type === 'image/jpeg')
                            storageRef = projectStorage.ref('/classroom/' + cid + '/images/' + eachFile.name)
                        else
                            storageRef = projectStorage.ref('/classroom/' + cid + '/docs/' + eachFile.name)
                        storageRef.put(eachFile).on('state_changed',
                            null,
                            err => console.log(err),
                            async () => {
                                const doc = {
                                    name: eachFile.name,
                                    url: await storageRef.getDownloadURL()
                                }
                                docs.push(doc)
                                if (docs.length >= res.length) {
                                    setDisable(false)
                                    toast.success('Upload successfull')
                                }
                            })
                    })
                })
                .catch(err => {
                    toast.error('Unsupported media')
                })
        } else if (e.target.files.length > 3) {
            toast.error('Cannot select more then 3 files')
        }
    }

    const handleChange = e => {
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    const handleSubmit = e => {
        e.preventDefault()
        values.time = new Date()
        values.docs = docs
        // console.log(values)
        sendMessage(cid, user.token, values)
            .then(res => {
                setValues(initialvals)
                document.getElementById('msg-file-input').value = ''
                setMessages(res.data)
                setDocs([])
            })
            .catch(err => {
                setDocs([])
                setValues(initialvals)
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
            })
    }

    const timeSince = date => {
        let seconds = Math.floor((new Date() - date) / 1000);
        let interval = seconds / 86400;
        if (interval > 1) {
            return `${date.getDate()}/${(date.getMonth() + 1)}/${date.getFullYear()}`;
        }
        interval = seconds / 3600;
        if (interval > 1) {
            return Math.floor(interval) + " hours";
        }
        interval = seconds / 60;
        if (interval > 1) {
            return Math.floor(interval) + " minutes";
        }
        return Math.floor(seconds) + " seconds";
    }

    return (
        <div className="messages-of-myclassroom-div">
            <form onSubmit={handleSubmit} className="row g-4">
                <div className="col-sm">
                    <input onChange={handleChange} type="text" name="title" value={values.title} className="form-control" placeholder="title" aria-label="title" required disabled={disable} />
                </div>
                <div className="col-sm-7">
                    <input onChange={handleChange} type="text" name="message" value={values.message} className="form-control" placeholder="message" aria-label="message" disabled={disable} />
                </div>
                <div className="col-sm">
                    <input onChange={handleDocSelect} id='msg-file-input' type="file" name="file-add-msg" accept="image/* doc/*" multiple disabled={disable} />
                </div>
                <div className="col-sm">
                    <button className="btn btn-primary" disabled={disable}>Send</button>
                </div>
            </form>
            <div style={{ marginTop: '30px' }} className="my-classroom-all-messages">
                {
                    loading ? <h1>loading</h1> :
                        (
                            (messages && messages.length) ? (messages.map((each, i) => {
                                return (
                                    <div key={i} style={{ maxWidth: '400px', margin: '3px auto' }} className="card">
                                        <div className="card-header"> {each.title} </div>
                                        <div className="card-body">
                                            <blockquote className="blockquote mb-0">
                                                <p>{each.message}</p>
                                                <footer className="blockquote-footer">{each.sent_by.name}<cite className="float-end">{timeSince(new Date(each.time))}</cite></footer>
                                                {(each.docs && each.docs.length) ? each.docs.map((eachDoc, i) => {
                                                    console.log(eachDoc.url)
                                                }) : ''
                                                }
                                            </blockquote>
                                        </div>
                                    </div>
                                )
                            }
                            )
                            ) : ''
                        )
                }
            </div>
        </div>
    );
};

export default Messages;